import React, { useState, useEffect, useRef } from 'react';
import { SVG } from '@svgdotjs/svg.js';

const Losas = () => 
{
  const canvasRef = useRef(null);
  const [b, setB] = useState(1.00); // Ancho de la Losa en metros
  const [h, setH] = useState(0.15); // Altura de la Losa en metros
  const [selectedLayer, setSelectedLayer] = useState('inferiorZ');
  const [zoom, setZoom] = useState(1);
  const [padding, setPadding] = useState(20); 
  const [ladoLargo, setLadoLargo] = useState('Z');
  const [MuX, setMuX] = useState();
  const [MuZ, setMuZ] = useState();

  const canvasSize = 1000;

  // Capas de refuerzo
  const [layers, setLayers] = useState({
    inferiorX: { numBars: 4, barDiameter: 10 },
    inferiorZ: { numBars: 5, barDiameter: 16 },
  });

  const barOptions = [8, 10, 12, 14, 16, 18, 20, 22, 25, 28, 32, 36]; // Diámetros en mm

  // Función de zoom
  const handleZoom = (event) => 
  {
    event.preventDefault();
    const delta = event.deltaY > 0 ? 0.9 : 1.1;
    setZoom((prevZoom) => Math.min(Math.max(prevZoom * delta, 0.5), 3));
  };

  // Cálculo de refuerzo intermedio
  useEffect(() => 
  {
    const maxDist = 0.6; // Distanciamiento máximo en metros
    setLayers((prevLayers) => ({
      ...prevLayers,
      intermedio: h > maxDist
        ? { numBars: 2, barDiameter: 12 }
        : { numBars: 0, barDiameter: 0 }
    }));
  }, [h]);

  useEffect(() => 
  {
    canvasRef.current.innerHTML = '';

    const draw = SVG().addTo(canvasRef.current).size('100%', '100%').viewbox(0, 0, canvasSize, canvasSize);
    const scale = canvasSize * zoom;

    const beamWidth = b * scale  ;
    const beamHeight = h * scale;
    const centerX = (canvasSize - beamWidth) / 2;
    const centerY = (canvasSize - beamHeight) / 2;

    // Dibujar la Losa Corte Eje X
    draw
      .rect(beamWidth, beamHeight)
      .fill('#e2e8f0')
      .stroke({ color: '#2d3748', width: 2 })
      .move(centerX, centerY - canvasSize/4);

    // Dibujar la Losa Corte Eje Z
    draw
      .rect(beamWidth, beamHeight)
      .fill('#e2e8f0')
      .stroke({ color: '#2d3748', width: 2 })
      .move(centerX, centerY + canvasSize/4);

    const drawInferiorBarsZ = () => 
    {
      const numBarsX = layers["inferiorX"].numBars;
      const barDiameterX = layers["inferiorX"].barDiameter;

      const numBarsZ = layers["inferiorZ"].numBars;
      const barDiameterZ = layers["inferiorZ"].barDiameter;

      const effectiveWidth = beamWidth - 2 * padding - barDiameterZ; // Consideramos el recubrimiento
      const barSpacing = Number(numBarsZ > 1 ? effectiveWidth / (numBarsZ - 1) : 0).toFixed(2); // Evitar división por 0 si hay solo 1 varilla

      for (let i = 0; i < numBarsZ; i++) 
      {
        draw
          .circle(barDiameterZ)
          .fill(selectedLayer === "inferiorZ" ? '#dc2626' : '#2d3748')
          .move(
            (canvasSize/2 + padding + i * barSpacing) - (beamWidth/2),
            (canvasSize/2 + beamHeight - padding - barDiameterZ) - (beamHeight/2) - (ladoLargo === 'X' ? barDiameterX : 0) - canvasSize/4
          )
          .click(() => setSelectedLayer("inferiorZ"));
      }

      draw
        .line(canvasSize/2 - beamWidth/2, centerY + beamHeight - padding - (ladoLargo === 'Z' ? barDiameterZ + barDiameterX/2 : barDiameterX/2) - canvasSize/4 , canvasSize/2 + beamWidth/2, centerY + beamHeight - padding - (ladoLargo === 'Z' ? barDiameterZ + barDiameterX/2 : barDiameterX/2) - canvasSize/4)
        .stroke({ color: selectedLayer === "inferiorX" ? '#dc2626' : '#2d3748', width: barDiameterX })
        .click(() => setSelectedLayer("inferiorX"));

      const dZ = Number(h - padding / 1000 - (barDiameterZ / 2) / 1000 - (ladoLargo === 'X' ? barDiameterX/1000 : 0)  ).toFixed(4);
      const dX = Number(h - padding / 1000 - (barDiameterZ / 2) / 1000 - (ladoLargo === 'Z' ? barDiameterX/1000 : 0)  ).toFixed(4);

      const AsX = calculateSteelArea(numBarsX, barDiameterX);
      const AsZ = calculateSteelArea(numBarsZ, barDiameterZ);

      setMuX(calculateBeamSectionUltimateMoment(1, dX, AsX));
      setMuZ(calculateBeamSectionUltimateMoment(1, dZ, AsZ));

    };

    const drawInferiorBarsX = () => 
    {
      const numBarsX = layers["inferiorX"].numBars;
      const barDiameterX = layers["inferiorX"].barDiameter;

      const barDiameterZ = layers["inferiorZ"].barDiameter;

      const effectiveWidth = beamWidth - 2 * padding - barDiameterZ; // Consideramos el recubrimiento
      const barSpacing = Number(numBarsX > 1 ? effectiveWidth / (numBarsX - 1) : 0).toFixed(2); // Evitar división por 0 si hay solo 1 varilla

      for (let i = 0; i < numBarsX; i++) 
      {
        draw
          .circle(barDiameterZ)
          .fill(selectedLayer === "inferiorX" ? '#dc2626' : '#2d3748')
          .move(
            (canvasSize/2 + padding + i * barSpacing) - (beamWidth/2),
            (canvasSize/2 + beamHeight - padding - barDiameterZ) - (beamHeight/2) - (ladoLargo === 'Z' ? barDiameterX : 0) + canvasSize/4
          )
          .click(() => setSelectedLayer("inferiorX"));
      }

      draw
      .line(canvasSize/2 - beamWidth/2, centerY + beamHeight - padding - (ladoLargo === 'X' ? barDiameterZ + barDiameterX/2 : barDiameterX/2) + canvasSize/4 , canvasSize/2 + beamWidth/2, centerY + beamHeight - padding - (ladoLargo === 'X' ? barDiameterZ + barDiameterX/2 : barDiameterX/2) + canvasSize/4)
      .stroke({ color: selectedLayer === "inferiorZ" ? '#dc2626' : '#2d3748', width: barDiameterX })
      .click(() => setSelectedLayer("inferiorZ"));
    };

    drawInferiorBarsZ();
    drawInferiorBarsX();

  }, [b, h, layers, selectedLayer, zoom, padding, ladoLargo]);

  // Función para calcular el área de refuerzo con número de barras y diámetro en mm
  const calculateSteelArea = (numBars, diameter) => 
  {
    const radius = diameter / 20; // Convertir mm a cm y obtener radio
    const areaOneBar = Math.PI * Math.pow(radius, 2); // Área de una barra
    return (areaOneBar * numBars).toFixed(2); // Área total en cm²
  };

  const calculateBeamSectionUltimateMoment = ( b, d, AsInput ) => 
  {
    //b en metros
    //d en metros 
    //As en cm²
    const beta1 = 0.85;   // Para concretos comunes
    const phi = 0.9;      // Factor de reducción de resistencia
    const fc = 210;       // Resistencia del concreto (kg/cm²)
    const fy = 4200;      // Esfuerzo de fluencia del acero (kg/cm²)
  
    // Convertir de metros a centímetros
    const bCm = b * 100;
    const dCm = d * 100;  
  
    const As = AsInput; // 6.03 cm2 es el área de 3 varillas de diámetro 16 mm, hay q revisar bien el acero mínimo
  
    // 2. Calcular a y c para Mu
    const c = (As * fy) / (0.85 * fc * bCm);
    const a = beta1 * c;
  
    // 3. Calcular el Momento Último
    const Mu = phi * As * fy * (dCm - (a / 2)); // kg·cm
  
    // Convertir de kg·cm a kg·m
    //const MuKgM = Mu / 100;

    // Convertir de kg·cm a T·m
    const MuTM = (Mu / 100) / 1000;  
  
    return Number(MuTM.toFixed(2));     
  };  

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Canvas para el dibujo */}
      <div
        className="w-5/6 flex items-center justify-center"
        onWheel={handleZoom}
      >
        <div
          ref={canvasRef}
          className="bg-white shadow w-full h-[100vh] overflow-hidden"
        ></div>
      </div>

      {/* Menú de configuración */}
      <div className="w-1/6 max-h-1/2 p-4 bg-white shadow rounded-lg">
        <h2 className="text-xl font-bold mb-4">Configuración</h2>
        <div className="mb-4">
          <label className="block text-gray-700">Ancho Losa (b) [m]:</label>
          <input
            type="number"
            step="0.05"
            min="0.15"
            max="1"
            value={b}
            disabled
            className="w-full border rounded p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Altura de la Losa (h) [m]:</label>
          <input
            type="number"
            step="0.05"
            min="0.15"
            max="0.40"
            value={h}
            onChange={(e) => 
              {
                const value = Number(e.target.value);
                const min = 0.15;
                const max = 1.00;
          
                if (isNaN(value) || value < min || value > max) {
                  alert(`Ingrese un valor entre ${min} y ${max} metros`);
                  return;
                }
          
                setH(value);
              }}
            className="w-full border rounded p-2"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Recubrimiento [cm]:</label>
          <input
            type="number"
            step="1"
            min="2"
            max="4"
            value={padding/10}

            onChange={(e) => 
              {
                const value = Number(e.target.value);
                const min = 2;
                const max = 10;
          
                if (isNaN(value) || value < min || value > max) {
                  alert(`Ingrese un valor entre ${min} y ${max} cm`);
                  return;
                }
          
                setPadding(parseFloat(value * 10))                
              }}
            className="w-full border rounded p-2"
          />
        </div>

        <h3 className="text-lg font-semibold mb-2">Capa Seleccionada: {selectedLayer.charAt(0).toUpperCase() + selectedLayer.slice(1)}</h3>
        <div className="mb-4">
          <label className="block text-gray-700">Número de Varillas:</label>
          <input
            type="number"
            min="3"
            max="10"
            value={layers[selectedLayer].numBars}
            onChange={(e) => 
              {
                const value = Number(e.target.value);
                const min = 3;
                const max = 10;
          
                if (isNaN(value) || value < min || value > max) 
                {
                  alert(`Ingrese un valor entre ${min} y ${max} varillas`);
                  return;
                }                       
          
                setLayers((prev) => ({
                  ...prev,
                  [selectedLayer]: { ...prev[selectedLayer], numBars: parseInt(value) }
                }))
              }}
            className="w-full border rounded p-2"
          />
          <label className="block text-gray-700">1∅{layers[selectedLayer].barDiameter}@{Number(100/(layers[selectedLayer].numBars - 1)).toFixed(2)}cm</label>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Diámetro de Barras [mm]:</label>
          <select
            value={layers[selectedLayer].barDiameter}
            onChange={(e) =>
              setLayers((prev) => ({
                ...prev,
                [selectedLayer]: { ...prev[selectedLayer], barDiameter: parseInt(e.target.value) }
              }))
            }
            className="w-full border rounded p-2"
          >
            {barOptions.map((diameter) => (
              <option key={diameter} value={diameter}>
                {diameter} mm
              </option>
            ))}
          </select>
        </div>
        
        <div className="mb-4">
          <label className="block text-gray-700">Lado Largo:</label>
          <select
            value={ladoLargo}
            onChange={(e) => setLadoLargo(e.target.value)}

            className="w-full border rounded p-2"
          >
            <option key={'Z'} value='Z'>
              Z
            </option>

            <option key={'X'} value='X'>
              X
            </option>            
          </select>
        </div>

        <h3 className="text-lg font-semibold my-1">Mu X</h3>
        <div className="mt-1 mb-2">
          <p className="text-xl">{MuX} T-m</p>
        </div>

        <h3 className="text-lg font-semibold my-1">Mu Z</h3>
        <div className="mt-1 mb-2">
          <p className="text-xl">{MuZ} T-m</p>
        </div>

      </div>      
    </div>
  );
};

export default Losas;